import { ComponentProps, ElementType } from 'react';
import styled from 'styled-components';
import BaseTab, { TabProps } from '@mui/material/Tab';

type StyledTabProps<C extends ElementType = ElementType> = TabProps & {
  $size?: 'small';
  component?: C;
} & ComponentProps<C>;

const Tab = styled(BaseTab)<StyledTabProps>`
  text-transform: none;
  color: ${({ theme }) => theme.palette.common.black};
  font-size: 14px;
  font-weight: 400;
  &.MuiTab-root {
    height: ${({ $size }) => ($size === 'small' ? '42px' : undefined)};
  }

  :hover {
    background-color: ${({ theme }) => theme.palette.common.gray10};
  }

  & > svg {
    color: ${({ theme }) => theme.palette.common.gray2};
  }

  &.Mui-selected {
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: ${({ theme }) => theme.typography.fontWeightMedium};

    & > svg {
      color: ${({ theme }) => theme.palette.text.primary};
    }
  }
`;

export default Tab;
